export const PUBLIC_RPC_URLS = [
  'https://mainnet.optimism.io',
  'https://optimism-rpc.publicnode.com',
];
const RETIRED_HOSTS = new Set(['1rpc.io', 'optimism.drpc.org']);
export function selectRpcUrls(configured = []) {
  return [...new Set([...configured, ...PUBLIC_RPC_URLS]
    .filter(url => typeof url === 'string').map(url => url.trim()).filter(url => {
      try { const parsed = new URL(url); return ['https:', 'http:'].includes(parsed.protocol) && !RETIRED_HOSTS.has(parsed.hostname); }
      catch { return false; }
    }))];
}
